import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { FilterMatchMode, LazyLoadEvent, MessageService, SelectItem } from 'primeng/api';
import Swal from 'sweetalert2';
import { helperService } from 'src/app/utils/helper';
import { matchModeOptionsDateList } from 'src/app/utils/filterDropDownData';
import { DisbursementsExportService } from './disbursements-export.service';

@Component({
    selector: 'app-disbursements-export',
    templateUrl: './disbursements-export.component.html',
    styleUrls: ['./disbursements-export.component.scss'],
    standalone: false
})
export class DisbursementsExportComponent implements OnInit {

  
  loading: boolean = false;
  totalRecords: number = 0;
  first: number = 1;
  cols:any[]=[];
  previewCols:any[]=[];
  gridCustomMessage:any=''
  previewData:any[]=[];
  disbRecordJobs:any[]=[];
  showTrDialog:Boolean=false;
  trForm:any=''
  title:any=''
  lastTableLazyLoadEvent: any;
  matchModeOptionsDate: SelectItem[]=matchModeOptionsDateList;
  exportSubscription:any=null;

  constructor(private exportService:DisbursementsExportService,private readonly messageService: MessageService,private helperService: helperService) {
    
    this.cols = [
      { field: 'id' },
      { field: 'createdDate'},
      { field: 'description' },
      { field: 'createdBy' },
      { field: 'recordsCount' },
    ];
    this.previewCols = [
      { field: 'id', header: 'ID' },
      { field: 'datePaid', header: 'Date Paid' },
      { field: 'taskId', header: 'Task ID' },
      { field: 'splOrgName', header: 'Payee Name' },
      { field: 'splMatterName', header: 'Matter Name' },
      { field: 'transactionType', header: 'Transaction Type' },
      { field: 'transAccountName', header: 'Transaction Account Name' },
      { field: 'splAccountName', header: 'Special Account Name' },
      { field: 'splReimbexp', header: 'Reimb Exp' },
      { field: 'splTaskDescription', header: 'Task Description' },
      { field: 'transName', header: 'Transaction Name' },
      { field: 'transDisbursementAmount', header: 'Disbursement Amount' },
    ];
    
    this.trForm = new UntypedFormGroup({
      id: new UntypedFormControl(''),
      datePaid: new UntypedFormControl(''),
      splAccountName: new UntypedFormControl(''),
      splOrgName: new UntypedFormControl(''),
      splMatterName: new UntypedFormControl(''),
      splReimbexp: new UntypedFormControl(''),
      splTaskDescription: new UntypedFormControl(''),
      taskId: new UntypedFormControl(''),
      transAccountName: new UntypedFormControl(''),
      transDisbursementAmount: new UntypedFormControl(''),
      transName: new UntypedFormControl(''),
      transactionType: new UntypedFormControl('')
    });

   }

  ngOnInit(): void {
  }
  generateData(){
    this.loading=true;
    this.exportService.generateExportData().subscribe(res=>{
      if(res===null){
        this.loading=false;
        Swal.fire("No records to Export.");
      }
      if(res.data.statusCode==200){
        this.loading=false;
          this.loadExportGrid(this.lastTableLazyLoadEvent);
      }

    })
  }
  preview(trData:any){
    this.title="Preview Data";
    this.previewData=trData["disbursementBatchDetails"];
    this.trForm.patchValue(trData["disbursementBatchDetails"]);
    this.trForm.disable();
    this.showTrDialog=true;
  
  }

  loadExportGrid(event:LazyLoadEvent){
    this.gridCustomMessage=''
    this.loading=true;
    this.lastTableLazyLoadEvent=event;
    this.disbRecordJobs=[]
    event.first = event?.first ? event.first : 1;
    event.rows = event?.rows ? event.rows : 10;

    let payload=this.helperService.generateEventPayload(event);
    if (this.exportSubscription) 
      this.exportSubscription.unsubscribe();
    this.exportSubscription = this.exportService.getAllBatchListPages(Math.floor(event.first / event.rows + 1), event.rows,payload).subscribe((res) =>{
          this.totalRecords=res?res.customValues?.totalNumberOfRecords:0; 
          this.disbRecordJobs=res.data;
          this.loading=false;
      }, res => {
        this.loading = false;
        this.gridCustomMessage=res.error.message?res.error.message:'';
      });
  }
  download( trData:any){
    console.log(trData)
    this.exportService.downloadBatch(trData.id).subscribe(res =>{
      const responseBody = res.body;
      if(res.headers.get('Content-Type')=="application/octet-stream"&& responseBody instanceof ArrayBuffer){
        const contentDisposition:any = res.headers.get('Content-Disposition');
        let fn;
        const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
        if (filenameMatch && filenameMatch[1]) {
          fn= filenameMatch[1].replace(/['"]/g, '');
        }
        this.saveFile(responseBody,fn);
      }
      else if (responseBody !== null){
        Swal.fire("Nothing to Download.");
      }
    },
    (error) => {
      console.error('Error fetching data', error);
    })
  }

  closeDialog(){
    this.loadExportGrid(this.lastTableLazyLoadEvent);
  }

  saveFile(data: ArrayBuffer,filename:any) {
    const blob = new Blob([data], { type: 'application/octet-stream' });
    const downloadLink = document.createElement('a');
    
    downloadLink.href = URL.createObjectURL(blob);
    downloadLink.download = filename; 
    downloadLink.click();
  
    URL.revokeObjectURL(downloadLink.href); 
  }
  
}

